import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

function Screen({ text, error }) {
  return <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]"><div className="surface p-8 text-center max-w-sm" data-testid="auth-callback"><img src="/logo-yumanabu.jpg" alt="Yumanabu" className="h-16 mx-auto mb-4 object-contain" /><p className={`text-sm ${error ? "text-red-600" : "text-slate-600"}`}>{text}</p>{error && <a href="/login" className="text-xs underline text-slate-500 mt-3 inline-block" data-testid="auth-callback-back">Kembali ke halaman login</a>}</div></div>;
}

// Menangani #session_id= dari Emergent Google Auth (dibaca dari useLocation().hash, bukan window.location.hash)
export function GoogleCallback() {
  const { hash } = useLocation();
  const nav = useNavigate();
  const { adopt } = useAuth();
  const done = useRef(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    api.post("/auth/google/session", { session_id: sid }).then(({ data }) => { adopt(data); window.history.replaceState(null, "", window.location.pathname); nav("/", { replace: true }); })
      .catch((e) => { setErr(errMsg(e)); toast.error(errMsg(e)); });
  }, [hash, nav, adopt]);
  return <Screen text={err || "Memverifikasi akun Google…"} error={!!err} />;
}

export default function MagicLogin() {
  const { token } = useParams();
  const nav = useNavigate();
  const { adopt } = useAuth();
  const done = useRef(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    api.post("/auth/magic-link/verify", { token }).then(({ data }) => { adopt(data); nav("/", { replace: true }); }).catch((e) => setErr(errMsg(e)));
  }, [token, nav, adopt]);
  return <Screen text={err || "Memverifikasi link masuk…"} error={!!err} />;
}
